module.exports = __webpack_public_path__ + "assets/img/snaperror.719a854d.png";